import { jarallax, jarallaxVideo } from "jarallax";

jarallaxVideo();

export default {
    init: function () {
        // Create the observer to lazy load videos
        let observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    // Initialize jarallax for the element when it comes into view
                    let node = entry.target;
                    let options = JSON.parse(node.dataset.jarallaxOptions || "");

                    if (options.disableMobile) {
                        options.disableMobile = /iPad|iPhone|iPod|Android/;
                    }

                    // Set the initial opacity to 0 to ensure it's hidden
                    node.style.opacity = '0';

                    jarallax(node, options);

                    // Fade in the jarallax element after a delay
                    setTimeout(function() {
                        node.style.transition = 'opacity 1.4s';
                        node.style.opacity = '1';
                    }, 1230);

                    // Stop observing this element once it's loaded
                    observer.unobserve(node);
                }
            });
        });

        // Observe each jarallax element
        document.querySelectorAll(".jarallax").forEach((node) => {
            observer.observe(node);
        });
    },
    cleanup: function () {
        jarallax(document.querySelectorAll(".jarallax"), "destroy");
    }
};
